"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HhnStorage = void 0;
const ChatsStorage_1 = __importDefault(require("./ChatsStorage"));
const OrgStorage_1 = __importDefault(require("./OrgStorage"));
const CommonStorage_1 = __importDefault(require("./CommonStorage"));
const ChatStorage_1 = require("./ChatStorage");
class HhnStorage {
    constructor(organizationId, networkManager) {
        this.orgStorage = new OrgStorage_1.default(organizationId);
        this.chatsStorage = new ChatsStorage_1.default(this.orgStorage, false);
        this.filteredChatsStorage = new ChatsStorage_1.default(this.orgStorage, true);
        this.commonStorage = new CommonStorage_1.default();
        this.chatStorage = new ChatStorage_1.ChatStorage(10, networkManager);
        this.filteredChatStorage = new ChatStorage_1.ChatStorage(1, networkManager);
    }
    resetExceptBadgeDependencies() {
        this.chatsStorage.reset();
        this.filteredChatsStorage.reset();
        this.chatStorage.reset();
        this.filteredChatStorage.reset();
        this.commonStorage.reset();
    }
    reset() {
        this.resetExceptBadgeDependencies();
        this.orgStorage.reset();
    }
}
exports.HhnStorage = HhnStorage;
